import React from 'react'
import clxs from 'clsx'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  bold: {
    fontWeight: 'bold'
  }
})

export type BoldProps = {
  className?: string
}

export const Bold: React.FC<BoldProps> = (props) => {
  const { children, className } = props
  const classes = useStyles()

  return <span className={clxs(classes.bold, className)}>{ children }</span>
}
